'use client';

import React from 'react';
import { VStack } from '@skin-seoul/design-system';
import FreeShippingSection from '../FreeShippingSection/FreeShippingSection';
import ProductInformationSection from '../ProductInformationSection/ProductInformationSection';
import SkinSightAwardSection from '../SkinSightAwardSection/SkinSightAwardSection';
import ProductRankingsSection from '../ProductRankingsSection/ProductRankingsSection';
import SuitableForSection from '../SuitableForSection/SuitableForSection';
import SuitableForSectionSkeleton from '../SuitableForSection/components/SuitableForSection.skeleton';
import LearnMoreWithVisualsSection from '../LearnMoreWithVisualsSection/LearnMoreWithVisualsSection';
import IngredientRatingsSection from '../IngredientRatingsSection/IngredientRatingsSection';
import IngredientRatingsSectionSkeleton from '../IngredientRatingsSection/components/IngredientRatingsSection.skeleton';
import StarIngredientsSection from '../StarIngredientsSection/StarIngredientsSection';
import StarIngredientsSectionSkeleton from '../StarIngredientsSection/components/StarIngredientsSection.skeleton';
import BrandSection from '../BrandSection/BrandSection';
import ProductRecentlyViewedSection from '../ProductRecentlyViewedSection/ProductRecentlyViewedSection';
import SkinSeoulSelectSectionSkeleton from '@/containers/home/sections/SkinSeoulSelectsSection/SkinSeoulSelectSection.skeleton';
import ProductSameCategorySection from '../ProductSameCategorySection/ProductSameCategorySection';
import { QueryBoundary } from '@/components/ui/QueryBoundary';
import SectionContainer from '@/components/shared/SectionContainer';
import { useParams } from 'next/navigation';
import { useProductService, useRegionCurrency } from '@skin-seoul/service';
import ReviewSection from '@/containers/product-detail/sections/ReviewSection/ReviewSection';
import ProductCompareSection from '@/components/products/ProductCompareSection/ProductCompareSection';
const ProductContentSection = () => {
  const {
    useGetProductsDetail
  } = useProductService();
  const {
    currency
  } = useRegionCurrency();
  const params = useParams();
  const {
    data: {
      product
    }
  } = useGetProductsDetail({
    slug: params.slug as string,
    currency
  });
  if (!product) {
    return null;
  }
  return <SectionContainer containerWrapperProps={{
    background: 'neutral.50'
  }} containerInnerProps={{
    paddingY: {
      base: 0,
      tablet: 0
    },
    paddingX: {
      base: 0,
      tablet: 6
    },
    borderRadius: {
      base: 0,
      tablet: 8
    },
    gap: {
      base: 0,
      tablet: 4
    }
  }} data-sentry-element="SectionContainer" data-sentry-component="ProductContentSection" data-sentry-source-file="ProductContentSection.tsx">
      <VStack background="white" borderRadius={{
      base: 0,
      tablet: 8
    }} paddingX={{
      base: 0,
      tablet: 10
    }} width="100%" gap={0} overflow="hidden" data-sentry-element="VStack" data-sentry-source-file="ProductContentSection.tsx">
        <FreeShippingSection data-sentry-element="FreeShippingSection" data-sentry-source-file="ProductContentSection.tsx" />
        {product.description && <ProductInformationSection />}
        <SkinSightAwardSection data-sentry-element="SkinSightAwardSection" data-sentry-source-file="ProductContentSection.tsx" />
        <ProductRankingsSection data-sentry-element="ProductRankingsSection" data-sentry-source-file="ProductContentSection.tsx" />

        <QueryBoundary clientOnly loadingFallback={<SuitableForSectionSkeleton />} data-sentry-element="QueryBoundary" data-sentry-source-file="ProductContentSection.tsx">
          <SuitableForSection productId={product.productId} data-sentry-element="SuitableForSection" data-sentry-source-file="ProductContentSection.tsx" />
        </QueryBoundary>

        <LearnMoreWithVisualsSection data-sentry-element="LearnMoreWithVisualsSection" data-sentry-source-file="ProductContentSection.tsx" />

        <QueryBoundary clientOnly loadingFallback={<IngredientRatingsSectionSkeleton />} data-sentry-element="QueryBoundary" data-sentry-source-file="ProductContentSection.tsx">
          <IngredientRatingsSection productId={product.productId} data-sentry-element="IngredientRatingsSection" data-sentry-source-file="ProductContentSection.tsx" />
        </QueryBoundary>

        <QueryBoundary clientOnly loadingFallback={<StarIngredientsSectionSkeleton />} data-sentry-element="QueryBoundary" data-sentry-source-file="ProductContentSection.tsx">
          <StarIngredientsSection productId={product.productId} data-sentry-element="StarIngredientsSection" data-sentry-source-file="ProductContentSection.tsx" />
        </QueryBoundary>
        <BrandSection data-sentry-element="BrandSection" data-sentry-source-file="ProductContentSection.tsx" />
        <ReviewSection product={product} data-sentry-element="ReviewSection" data-sentry-source-file="ProductContentSection.tsx" />
        <ProductCompareSection currentProductId={Number(product.productId)} containerProps={{
        width: '100%',
        background: 'white',
        borderTop: '1px solid',
        borderColor: 'neutral.100',
        borderRadius: {
          base: 0
        },
        paddingX: {
          base: 0
        },
        paddingY: 4,
        height: 'fit-content',
        gap: 4,
        overflow: 'hidden'
      }} data-sentry-element="ProductCompareSection" data-sentry-source-file="ProductContentSection.tsx" />
        <QueryBoundary clientOnly loadingFallback={<SkinSeoulSelectSectionSkeleton />} data-sentry-element="QueryBoundary" data-sentry-source-file="ProductContentSection.tsx">
          <ProductRecentlyViewedSection data-sentry-element="ProductRecentlyViewedSection" data-sentry-source-file="ProductContentSection.tsx" />
        </QueryBoundary>

        <QueryBoundary clientOnly loadingFallback={<SkinSeoulSelectSectionSkeleton />} data-sentry-element="QueryBoundary" data-sentry-source-file="ProductContentSection.tsx">
          <ProductSameCategorySection data-sentry-element="ProductSameCategorySection" data-sentry-source-file="ProductContentSection.tsx" />
        </QueryBoundary>
      </VStack>
    </SectionContainer>;
};
export default ProductContentSection;